export default {
  viewBox: "0 0 24 24",
  html: "<path fill-rule=\"evenodd\" d=\"M0 20h24v4H0zm5.224-8.036 1.113 1.112L3 16.413h4.449L8.561 15.3l1.112 1.112 4.45-4.45-4.45-4.448zm9.225-9.225a1.11 1.11 0 0 1 1.57 0l2.88 2.878a1.115 1.115 0 0 1 0 1.571l-3.664 3.664-4.45-4.45z\"/>"
};